import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddAiChatMessageNonAdminMutationVariables = Types.Exact<{
  message: Types.Scalars['String']['input'];
  userId: Types.Scalars['String']['input'];
  workspaceId: Types.Scalars['Int']['input'];
  workspaceLocationId: Types.Scalars['Int']['input'];
  chatId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  parentMessageId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  chatSource?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type AddAiChatMessageNonAdminMutation = { __typename?: 'mutation_root', newChatMessage?: Array<{ __typename?: 'newChatMessageOutput', chatId: string, senderId?: string | null, message?: { __typename?: 'messages', id: any, body?: string | null, aiChatId?: string | null, aiChatMessageId?: string | null, messageType: string, createdAt: any, parentMessageId?: any | null, senderId?: string | null, private: boolean, anonymous: boolean, user?: { __typename?: 'users', id: string, firstName: string, lastName: string, profilePhotoLink?: string | null } | null, snippets: Array<{ __typename?: 'relevantSnippets', id: any, documentName?: string | null, url?: string | null, relevantMessageId?: any | null, snippetText?: string | null, relevantMessage?: { __typename?: 'messages', id: any, parentMessageId?: any | null, private: boolean, messageReceivers: Array<{ __typename?: 'messageReceivers', id: any, userId?: string | null, roleId?: number | null, specialtyId?: any | null }> } | null }> } | null } | null> | null };


export const AddAiChatMessageNonAdminDocument = gql`
    mutation addAiChatMessageNonAdmin($message: String!, $userId: String!, $workspaceId: Int!, $workspaceLocationId: Int!, $chatId: String, $parentMessageId: String, $chatSource: String) {
  newChatMessage(
    message: $message
    userId: $userId
    workspaceId: $workspaceId
    workspaceLocationId: $workspaceLocationId
    chatId: $chatId
    parentMessageId: $parentMessageId
    chatSource: $chatSource
  ) {
    chatId
    senderId
    message {
      id
      body
      aiChatId
      aiChatMessageId
      messageType
      createdAt
      parentMessageId
      senderId
      private
      anonymous
      user {
        id
        firstName
        lastName
        profilePhotoLink
      }
      snippets {
        id
        documentName
        url
        relevantMessageId
        snippetText
        relevantMessage {
          id
          parentMessageId
          messageReceivers {
            id
            userId
            roleId
            specialtyId
          }
          private
        }
      }
    }
  }
}
    `;
export type AddAiChatMessageNonAdminMutationFn = Apollo.MutationFunction<AddAiChatMessageNonAdminMutation, AddAiChatMessageNonAdminMutationVariables>;

/**
 * __useAddAiChatMessageNonAdminMutation__
 *
 * To run a mutation, you first call `useAddAiChatMessageNonAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAiChatMessageNonAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAiChatMessageNonAdminMutation, { data, loading, error }] = useAddAiChatMessageNonAdminMutation({
 *   variables: {
 *      message: // value for 'message'
 *      userId: // value for 'userId'
 *      workspaceId: // value for 'workspaceId'
 *      workspaceLocationId: // value for 'workspaceLocationId'
 *      chatId: // value for 'chatId'
 *      parentMessageId: // value for 'parentMessageId'
 *      chatSource: // value for 'chatSource'
 *   },
 * });
 */
export function useAddAiChatMessageNonAdminMutation(baseOptions?: Apollo.MutationHookOptions<AddAiChatMessageNonAdminMutation, AddAiChatMessageNonAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAiChatMessageNonAdminMutation, AddAiChatMessageNonAdminMutationVariables>(AddAiChatMessageNonAdminDocument, options);
      }
export type AddAiChatMessageNonAdminMutationHookResult = ReturnType<typeof useAddAiChatMessageNonAdminMutation>;
export type AddAiChatMessageNonAdminMutationResult = Apollo.MutationResult<AddAiChatMessageNonAdminMutation>;
export type AddAiChatMessageNonAdminMutationOptions = Apollo.BaseMutationOptions<AddAiChatMessageNonAdminMutation, AddAiChatMessageNonAdminMutationVariables>;